import { render, staticRenderFns } from "./ContactDeleteModal.vue?vue&type=template&id=82a6c812"
import script from "./ContactDeleteModal.vue?vue&type=script&lang=js"
export * from "./ContactDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports